// // ============================================
// // src/components/home/AboutContent.tsx
// // ============================================
// "use client";
// import { Box, Typography, Grid } from '@mui/material';
// import { aboutBlocks } from '@/data/aboutData';

// interface AboutContentProps {
//   isVisible: boolean;
// }

// export default function AboutContent({ isVisible }: AboutContentProps) {
//   return (
//     <Box sx={{ mb: 6 }}>
//       <Grid 
//         container 
//         spacing={4}
//         justifyContent="space-between" // ← Esto separa los bloques
//         sx={{ 
//           // Asegurar que los bloques no sean muy anchos
//           maxWidth: '90%',
//           mx: 'auto',
//         }}
//       >
//         {aboutBlocks.map((block, index) => {
//           const IconComponent = block.icon;
//           const isLeftBlock = index === 0;
          
//           return (
//             <Grid 
//               key={index} 
//               size={{ xs: 12, md: 4 }} // Un poco menos de 6 para dar espacio
//               sx={{
//                 // Ajustes específicos para cada bloque
//                 ml: isLeftBlock ? { md: 0 } : 0,
//                 mr: !isLeftBlock ? { md: 0 } : 0,
//               }}
//             >
//               <Box
//                 sx={{
//                   opacity: isVisible ? 1 : 0,
//                   transform: isVisible ? 'translateX(0)' : isLeftBlock ? 'translateX(-30px)' : 'translateX(30px)',
//                   transition: `all 1s cubic-bezier(0.4, 0, 0.2, 1) ${0.2 + index * 0.1}s`,
//                   height: '100%',
//                 }}
//               >
//                 <Box
//                   sx={{
//                     background: block.gradient,
//                     borderRadius: 3,
//                     p: 4,
//                     height: '100%',
//                     border: `1px solid ${block.borderColor}`,
//                     position: 'relative',
//                     overflow: 'hidden',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     '&::before': {
//                       content: '""',
//                       position: 'absolute',
//                       top: -50,
//                       left: isLeftBlock ? -50 : 'auto',
//                       right: !isLeftBlock ? -50 : 'auto',
//                       width: 200,
//                       height: 200,
//                       background: 'rgba(255, 255, 255, 0.15)',
//                       borderRadius: '50%',
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 2,
//                       mb: 3,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         width: 56,
//                         height: 56,
//                         borderRadius: 2,
//                         bgcolor: 'rgba(255, 255, 255, 0.25)',
//                         backdropFilter: 'blur(10px)',
//                       }}
//                     >
//                       <IconComponent sx={{ fontSize: 32, color: 'white' }} />
//                     </Box>
//                     <Box>
//                       <Typography
//                         variant="h6"
//                         sx={{
//                           fontWeight: 700,
//                           color: 'white',
//                           mb: 0.5,
//                         }}
//                       >
//                         {block.title}
//                       </Typography>
//                       {block.subtitle && (
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             color: 'rgba(255, 255, 255, 0.8)',
//                             fontSize: '0.975rem',
//                           }}
//                         >
//                           {block.subtitle}
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>

//                   <Box sx={{ position: 'relative', zIndex: 1, flexGrow: 1 }}>
//                     {block.content.map((paragraph, paraIndex) => (
//                       <Typography
//                         key={paraIndex}
//                         variant="body1"
//                         sx={{
//                           color: 'rgba(255, 255, 255, 0.9)',
//                           lineHeight: 1.8,
//                           mb: paraIndex < block.content.length - 1 ? 2 : 0,
//                           fontSize: paraIndex > 0 ? '1rem' : '1.05rem',
//                         }}
//                       >
//                         {paragraph}
//                       </Typography>
//                     ))}
//                   </Box>
//                 </Box>
//               </Box>
//             </Grid>
//           );
//         })}
//       </Grid>
//     </Box>
//   );
// }







// ============================================
// src/components/home/AboutContent.tsx
// ============================================
"use client";

import { memo, useMemo } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { aboutBlocks } from '@/data/aboutData';

interface AboutContentProps {
  isVisible: boolean;
}

// Componente memoizado para cada bloque individual
const AboutBlock = memo(({ 
  block, 
  index, 
  isVisible 
}: { 
  block: typeof aboutBlocks[0]; 
  index: number; 
  isVisible: boolean;
}) => {
  const IconComponent = block.icon;
  const isLeftBlock = index === 0;
  
  const animationStyle = useMemo(() => ({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateX(0)' : isLeftBlock ? 'translateX(-30px)' : 'translateX(30px)',
    transition: `all 1s cubic-bezier(0.4, 0, 0.2, 1) ${0.2 + index * 0.1}s`,
    height: '100%',
  }), [isVisible, isLeftBlock, index]);

  const gradientBoxStyle = useMemo(() => ({
    background: block.gradient,
    borderRadius: 3,
    p: 4,
    height: '100%',
    border: `1px solid ${block.borderColor}`,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -50,
      left: isLeftBlock ? -50 : 'auto',
      right: !isLeftBlock ? -50 : 'auto',
      width: 200,
      height: 200,
      background: 'rgba(255, 255, 255, 0.15)',
      borderRadius: '50%',
    },
  }), [block.gradient, block.borderColor, isLeftBlock]);

  return (
    <Box sx={{ opacity: isVisible ? 1 : 0, height: '100%' }}>
      <Box sx={animationStyle}>
        <Box sx={gradientBoxStyle}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 56,
                height: 56,
                borderRadius: 2,
                bgcolor: 'rgba(255, 255, 255, 0.25)',
                backdropFilter: 'blur(10px)',
              }}
            >
              <IconComponent sx={{ fontSize: 32, color: 'white' }} />
            </Box>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: 'white',
                  mb: 0.5,
                }}
              >
                {block.title}
              </Typography>
              {block.subtitle && (
                <Typography
                  variant="body2"
                  sx={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '0.975rem',
                  }}
                >
                  {block.subtitle}
                </Typography>
              )}
            </Box>
          </Box>

          <Box sx={{ position: 'relative', zIndex: 1, flexGrow: 1 }}>
            {block.content.map((paragraph, paraIndex) => (
              <Typography
                key={paraIndex}
                variant="body1"
                sx={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  lineHeight: 1.8,
                  mb: paraIndex < block.content.length - 1 ? 2 : 0,
                  fontSize: paraIndex > 0 ? '1rem' : '1.05rem',
                }}
              >
                {paragraph}
              </Typography>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

AboutBlock.displayName = 'AboutBlock';

// Componente principal memoizado
const AboutContent = memo(({ isVisible }: AboutContentProps) => {
  const gridSizes = useMemo(() => ({ xs: 12, md: 4 }), []);
  
  return (
    <Box sx={{ mb: 6 }}>
      <Grid 
        container 
        spacing={4}
        justifyContent="space-between"
        sx={{ 
          maxWidth: '90%',
          mx: 'auto',
        }}
      >
        {aboutBlocks.map((block, index) => {
          const isLeftBlock = index === 0;
          
          return (
            <Grid 
              key={index} 
              size={gridSizes}
              sx={{
                ml: isLeftBlock ? { md: 0 } : 0,
                mr: !isLeftBlock ? { md: 0 } : 0,
              }}
            >
              <AboutBlock 
                block={block} 
                index={index} 
                isVisible={isVisible} 
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
});

AboutContent.displayName = 'AboutContent';

export default AboutContent;